<template>
<div class="row">
  <div v-for="(plan, index) in plans" :key="index" class="col">

    <b-card :title="plan.name" :sub-title='plan.value | decimal'>
      <b-card-text>
        <div class="ml-2">
          <template v-if="plan.users == 'Ilimitado'">
            <i style="color: blue" class="fas fa-check" /><span class="ml-2">{{ plan.users }}</span>
          </template>
          <template v-else>
            <i style="color: blue" class="fas fa-check" /><span class="ml-2">{{ plan.users }} Usuários</span>
          </template>
        </div>
        <div class="ml-2">
          <template v-if="plan.nfe == 0">
            <i style="color: red" class="fas  fa-times" /><span class="ml-2"> NF-e</span>
          </template>
          <template v-else>
            <i style="color: blue" class="fas fa-check" /><span class="ml-2">{{ plan.nfe }} NF-e</span>
          </template>
        </div>
        <div class="ml-2">
          <template v-if="plan.nfce == 0">
            <i style="color: red" class="fas  fa-times" /><span class="ml-2">NFC-e </span>
          </template>
          <template v-else>
            <i style="color: blue" class="fas fa-check" /><span class="ml-2">{{ plan.nfce }} NFC-e</span>
          </template>
        </div>
      </b-card-text>
      <b-card-text class="d-flex justify-content-center">
        <b-button variant="success" @click="select(plan)">Assinar</b-button>
      </b-card-text>
    </b-card>
  </div>
</div>
</template>

<script>
export default {

  data: function () {
    return {

      new_subscription: {
        type: 'new_subscription',
        plan: {},
      },

      plans: {}

    };
  },

  mounted() {
    axios
      .post("api/subscribe/plans")
      .then(response => {
        this.$store.commit("pageHasLoaded");

        this.plans = response.data.plans.data;

        this.$store.commit("userHasLoaded");
      })
      .catch(error => {
        this.error = error;

      });
  },

  methods: {
    select(plan) {
      this.new_subscription.plan = plan
      this.$emit("subscribe", this.new_subscription);
    }
  }
};
</script>
